<template>
  <page-outline
    class="page"
    :title="$t('Webheader.rtp_global_settings')"
    colWidth="6"
  >
    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <div class="ml-2 mt-xl-0">
          <b-button-group class="">
            <b-button :variant="tabName === 0 ? 'primary' : ''" @click="tabName = 0; resetSettings()">{{ $t('settings.global_label') }}</b-button>
            <b-button v-if="canSeeSRTP" :variant="tabName === 1 ? 'primary' : ''" @click="tabName = 1; resetSettings()">{{ $t('settings.eba_label') }}</b-button>
            <b-button v-if="canSeeHRTP" :variant="tabName === 2 ? 'primary' : ''" @click="tabName = 2; resetSettings()">{{ $t('settings.giro_label') }}</b-button>
            <b-button v-if="canSeePSD2" :variant="tabName === 3 ? 'primary' : ''" @click="tabName = 3; resetSettings()">{{ $t('common.norm.psd2') }}</b-button>
          </b-button-group>
        </div>
        <b-tabs v-model="tabName" class="mt-3" nav-class="d-none">
          <!--GENERAL SETTINGS-->
          <b-tab>
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-write-group-label-input
                  v-model="settings['RTPMaxLinesExport']" :disabled="!doesEdit" :key="'maxLine'+resetInput"
                  :maxLength="21"
                  inputType="number"
                  :inputLabel="$t('settings.max_lines_export')"
                  horizontal
                  @input="changeMaxLinesExportRTP">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-write-group-label-input
                  inputType="other" :key="'environment'+resetInput"
                  inputClass="inputParentFormWriteGroup"
                  :inputLabel="$t('settings.environnment_type')"
                  horizontal>
                    <select v-model="settings['Environment']" class="form-control pr-5 col-7" :disabled="!doesEdit">
                      <option v-for="(env, index) in environnments" :key="env.name + '-' + index" :value="env.value">{{ $t('settings.' + env.name) }}</option>
                    </select>
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </b-tab>
          <!--EBA SETTINGS-->
          <b-tab>
            <form-accordion :title="$t('settings.general_sttngs')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings.RTPSPIdentifier" :disabled="!doesEdit"
                    inputType="text"
                    :inputLabel="$t('administration.rtp_identifier')"
                    horizontal>
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['SRTP-API-AccountValidation']" :disabled="!doesEdit"
                    inputType="other"
                    :inputLabel="$t('administration.rtp_api_accountvalidation')"
                    horizontal>
                    <b-form-checkbox v-model="settings['SRTP-API-AccountValidation']" value="1" unchecked-value="0" :disabled="!doesEdit"></b-form-checkbox>
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['SRTP-RTPSPMaxAmount']" :disabled="!doesEdit" :key="'srtpMaxAmount'+resetInput"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="number"
                    :inputLabel="$t('settings.max_amnt_srtp')"
                    horizontal
                    @input="controlMaxAmountSRTP"
                    @blur="changeMaxAmountSRTP">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings.RTPSPTimeBeforeExpiration" :disabled="!doesEdit" :key="'SRTPExp'+resetInput"
                    :maxLength="21"
                    inputType="number"
                    :inputLabel="$t('administration.rtp_time_before_expiration')"
                    horizontal
                    @input="controlTimeBeforeExpSRTP"
                    @blur="changeTimeBeforeExpSRTP">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.archive')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label class="col-5 d-flex align-items-end">{{ $t('settings.srtp_archive_freq') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                        v-model="srtpArchiveFrequenceYear" :disabled="!doesEdit" :key="'srtpArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpArchiveFrequenceMonth" :disabled="!doesEdit" :key="'srtpArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpArchiveFrequenceDay" :disabled="!doesEdit" :key="'srtpArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label class="col-5 d-flex align-items-end">{{ $t('settings.srtp_archive_delay') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                        v-model="srtpArchiveDelayYear" :disabled="!doesEdit" :key="'srtpArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpArchiveDelayMonth" :disabled="!doesEdit" :key="'srtpArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpArchiveDelayDay" :disabled="!doesEdit" :key="'srtpArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="srtpLastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.srtp_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.purge')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label class="col-5 d-flex align-items-end">{{ $t('settings.srtp_purge_freq') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                        v-model="srtpPurgeFrequenceYear" :disabled="!doesEdit" :key="'srtpPurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpPurgeFrequenceMonth" :disabled="!doesEdit" :key="'srtpPurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpPurgeFrequenceDay" :disabled="!doesEdit" :key="'srtpPurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label class="col-5 d-flex align-items-end">{{ $t('settings.srtp_purge_delay') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                        v-model="srtpPurgeDelayYear" :disabled="!doesEdit" :key="'srtpPurDelqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpPurgeDelayMonth" :disabled="!doesEdit" :key="'srtpPurDelqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpPurgeDelayDay" :disabled="!doesEdit" :key="'srtpPurDelqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="srtpLastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.srtp_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
          <!--GIRO SETTINGS-->
          <b-tab>
            <form-accordion :title="$t('settings.general_sttngs')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['HRTP-Identifier']" :disabled="!doesEdit"
                    inputType="text"
                    :inputLabel="$t('administration.hrtp_identifier')"
                    horizontal>
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['HRTP-API-AccountValidation']" :disabled="!doesEdit"
                    inputType="other"
                    :inputLabel="$t('administration.hrtp_api_accountvalidation')"
                    horizontal>
                    <b-form-checkbox v-model="settings['HRTP-API-AccountValidation']" value="1" unchecked-value="0" :disabled="!doesEdit"></b-form-checkbox>
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['HRTP-RTPSPMaxAmount']" :disabled="!doesEdit" :key="'hrtpMaxAmount'+resetInput"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="number"
                    :inputLabel="$t('settings.max_amnt_hrtp')"
                    horizontal
                    @input="controlMaxAmountHRTP"
                    @blur="changeMaxAmountHRTP">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['HRTP-ValidityPeriod']" :disabled="!doesEdit" :key="'hrtpExp'+resetInput"
                    :maxLength="21"
                    inputType="number"
                    :inputLabel="$t('administration.rtp_h_validity_period')"
                    horizontal
                    @input="controlTimeBeforeExpHRTP"
                    @blur="changeVldityPeriodHRTP">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.archive')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_archive_freq') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                        v-model="hrtpArchiveFrequenceYear" :disabled="!doesEdit" :key="'hrtpArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpArchiveFrequenceMonth" :disabled="!doesEdit" :key="'hrtpArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpArchiveFrequenceDay" :disabled="!doesEdit" :key="'hrtpArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_archive_delay') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                        v-model="hrtpArchiveDelayYear" :disabled="!doesEdit" :key="'hrtpArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpArchiveDelayMonth" :disabled="!doesEdit" :key="'hrtpArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpArchiveDelayDay" :disabled="!doesEdit" :key="'hrtpArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="hrtpLastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.hrtp_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.purge')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_purge_freq') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                        v-model="hrtpPurgeFrequenceYear" :disabled="!doesEdit" :key="'hrtpPurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpPurgeFrequenceMonth" :disabled="!doesEdit" :key="'hrtpPurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpPurgeFrequenceDay" :disabled="!doesEdit" :key="'hrtpPurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_purge_delay') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                        v-model="hrtpPurgeDelayYear" :disabled="!doesEdit" :key="'hrtpPurgDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpPurgeDelayMonth" :disabled="!doesEdit" :key="'hrtpPurgDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpPurgeDelayDay" :disabled="!doesEdit" :key="'hrtpPurgDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="hrtpLastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.hrtp_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
          <!-- PSD2 Settings -->
          <b-tab>
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-write-group-label-input
                v-model="settings['PSD2-Token.io-RedirectURL']" :disabled="!doesEdit" :key="'psd2tokenioredirect'+resetInput"
                inputType="text"
                :inputLabel="$t('settings.tokenio_redirecturl')"
                horizontal>
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <form-accordion :title="$t('settings.archive')" class="ml-2" :isTitleUpperCase="false">
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                  <label class="col-5 d-flex align-items-end">{{ $t('settings.psd2_archive_freq') }}</label>
                  <div class="d-flex col-7">
                    <form-write-group-label-input
                      v-model="psd2ArchiveFrequenceYear" :disabled="!doesEdit" :key="'psd2ArchFrqY'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.year')">
                    </form-write-group-label-input>
                    <form-write-group-label-input
                      v-model="psd2ArchiveFrequenceMonth" :disabled="!doesEdit" :key="'psd2ArchFrqM'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.month')">
                    </form-write-group-label-input>
                    <form-write-group-label-input
                      v-model="psd2ArchiveFrequenceDay" :disabled="!doesEdit" :key="'psd2ArchFrqD'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.day')">
                    </form-write-group-label-input>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                  <label class="col-5 d-flex align-items-end">{{ $t('settings.psd2_archive_delay') }}</label>
                  <div class="d-flex col-7">
                    <form-write-group-label-input
                      v-model="psd2ArchiveDelayYear" :disabled="!doesEdit" :key="'psd2ArchDelY'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.year')">
                    </form-write-group-label-input>
                    <form-write-group-label-input
                      v-model="psd2ArchiveDelayMonth" :disabled="!doesEdit" :key="'psd2ArchDelM'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.month')">
                    </form-write-group-label-input>
                    <form-write-group-label-input
                      v-model="psd2ArchiveDelayDay" :disabled="!doesEdit" :key="'psd2ArchDelD'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.day')">
                    </form-write-group-label-input>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-read-group-label-input
                  :inputValue="psd2LastArchive"
                  :maxLength="21"
                  class="justify-content-around"
                  inputType="text"
                  :inputLabel="$t('settings.psd2_last_archive')"
                  horizontal
                  >
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <form-accordion :title="$t('settings.purge')" class="ml-2" :isTitleUpperCase="false">
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                  <label class="col-5 d-flex align-items-end">{{ $t('settings.psd2_purge_freq') }}</label>
                  <div class="d-flex col-7">
                    <form-write-group-label-input
                      v-model="psd2PurgeFrequenceYear" :disabled="!doesEdit" :key="'psd2PurgFrqY'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.year')">
                    </form-write-group-label-input>
                    <form-write-group-label-input
                      v-model="psd2PurgeFrequenceMonth" :disabled="!doesEdit" :key="'psd2PurgFrqM'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.month')">
                    </form-write-group-label-input>
                    <form-write-group-label-input
                      v-model="psd2PurgeFrequenceDay" :disabled="!doesEdit" :key="'psd2PurgFrqD'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.day')">
                    </form-write-group-label-input>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                  <label class="col-5 d-flex align-items-end">{{ $t('settings.psd2_purge_delay') }}</label>
                  <div class="d-flex col-7">
                    <form-write-group-label-input
                      v-model="psd2PurgeDelayYear" :disabled="!doesEdit" :key="'psd2PurgDelY'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.year')">
                    </form-write-group-label-input>
                    <form-write-group-label-input
                      v-model="psd2PurgeDelayMonth" :disabled="!doesEdit" :key="'psd2PurgDelM'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.month')">
                    </form-write-group-label-input>
                    <form-write-group-label-input
                      v-model="psd2PurgeDelayDay" :disabled="!doesEdit" :key="'psd2PurgDelD'+resetInput"
                      :maxLength="21"
                      class="justify-content-around"
                      inputType="number"
                      :inputLabel="$t('common.day')">
                    </form-write-group-label-input>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-read-group-label-input
                  :inputValue="psd2LastPurge"
                  :maxLength="21"
                  class="justify-content-around"
                  inputType="text"
                  :inputLabel="$t('settings.psd2_last_purge')"
                  horizontal
                  >
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-10 offset-md-1" v-if="hasRight('application_global_rtp_settings_editer')">
        <b-row class="justify-content-end no-gutters" v-if="!doesEdit">
          <b-button @click="editSettings" variant="primary">
            <span>{{ $t("administration.edit") }}</span>
          </b-button>
        </b-row>
        <b-row v-else class="justify-content-end no-gutters">
          <div>
            <b-button @click="resetSettings" variant="primary">
              <span>{{ $t("common.cncl") }}</span>
            </b-button>
          </div>
          <div class="pl-3">
            <b-button @click="updateSettings(settings)" variant="primary">
              <span>{{ $t("common.update") }}</span>
            </b-button>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from 'moment'
import PageOutline from "@/components/common/PageOutline.vue"
import FormAccordion from "@/components/common/FormAccordion.vue"
import Spinner from "@/components/common/spinner.vue"
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import formReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import { errorMessageAlert } from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'
import { formatDateTime } from '@/helpers/format'

export default {
  name: "RTPSettings",
  components: {
    "page-outline": PageOutline,
    "form-accordion": FormAccordion,
    spinner: Spinner,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "form-read-group-label-input": formReadGroupLabelInput,
  },
  data () {
    return {
      activateSpinner: false,
      comaCount: 0,
      doesEdit: false,
      environnments: {},
      originalSettings: {},
      resetInput: false,
      settings: {
        'RTPMaxLinesExport': '',
        'Environment': '',
        RTPSPIdentifier: '',
        RTPSPTimeBeforeExpiration: '',
        'SRTP-API-AccountValidation': '',
        'SRTP-RTPSPMaxAmount': '',
        'HRTP-API-AccountValidation': '',
        'HRTP-RTPSPMaxAmount': '',
        'HRTP-ValidityPeriod': '',
        'SRTP-PurgeFrequence': '',
        'HRTP-PurgeFrequence': '',
        'PSD2-PurgeFrequence': '',
        'SRTP-PurgeDelay': '',
        'HRTP-PurgeDelay': '',
        'PSD2-PurgeDelay': '',
        'SRTP-ArchiveFrequence': '',
        'HRTP-ArchiveFrequence': '',
        'PSD2-ArchiveFrequence': '',
        'SRTP-ArchiveDelay': '',
        'HRTP-ArchiveDelay': '',
        'PSD2-ArchiveDelay': '',
        SRTP_LastPurge: '',
        HRTP_LastPurge: '',
        PSD2_LastPurge: '',
        SRTP_LastArchive: '',
        HRTP_LastArchive: '',
        PSD2_LastArchive: '',
      },
      tabName: 0
    }
  },
  computed: {
    canSeeSRTP () {
      if (this.$engine.rights.rightIs('super_admin', true)) {
        return true
      } else if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '1' && this.$engine.rights.rightIs('rtp_norm_srtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_srtp', true)
      }
    },
    canSeeHRTP () {
      if (this.$engine.rights.rightIs('super_admin', true)) {
        return true
      } else if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '2' && this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      }
    },
    canSeePSD2 () {
      if (this.$engine.rights.rightIs('super_admin', true)) {
        return true
      } else if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '3' && this.$engine.rights.rightIs('rtp_norm_psd2', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_psd2', true)
      }
    },
    hrtpArchiveDelayYear : {
      get () {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['HRTP-ArchiveDelay'] ? this.originalSettings['HRTP-ArchiveDelay'].split(',')[0] : '0'
        }
        if (this.settings['HRTP-ArchiveDelay']) {
          this.settings['HRTP-ArchiveDelay'] = newYear + ',' + this.hrtpArchiveDelayMonth + ',' + this.hrtpArchiveDelayDay
        } else {
          this.settings['HRTP-ArchiveDelay'] = newYear + ',0,0'
        }
      }
    },
    hrtpArchiveDelayMonth : {
      get () {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['HRTP-ArchiveDelay'] ? this.originalSettings['HRTP-ArchiveDelay'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-ArchiveDelay']) {
          this.settings['HRTP-ArchiveDelay'] = this.hrtpArchiveDelayYear + ',' + newMonth + ',' + this.hrtpArchiveDelayDay
        } else {
          this.settings['HRTP-ArchiveDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    hrtpArchiveDelayDay : {
      get () {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['HRTP-ArchiveDelay'] ? this.originalSettings['HRTP-ArchiveDelay'].split(',')[2] : '0'
        }
        if (this.settings['HRTP-ArchiveDelay']) {
          this.settings['HRTP-ArchiveDelay'] = this.hrtpArchiveDelayYear + ',' + this.hrtpArchiveDelayMonth + ',' + newDay
        } else {
          this.settings['HRTP-ArchiveDelay'] = '0,0,' + newDay
        }
      }
    },
    hrtpArchiveFrequenceYear : {
      get () {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['HRTP-ArchiveFrequence'] ? this.originalSettings['HRTP-ArchiveFrequence'].split(',')[0] : '0'
        }
        if (this.settings['HRTP-ArchiveFrequence']) {
          this.settings['HRTP-ArchiveFrequence'] = newYear + ',' + this.hrtpArchiveFrequenceMonth + ',' + this.hrtpArchiveFrequenceDay
        } else {
          this.settings['HRTP-ArchiveFrequence'] = newYear + ',0,0'
        }
      }
    },
    hrtpArchiveFrequenceMonth : {
      get () {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['HRTP-ArchiveFrequence'] ? this.originalSettings['HRTP-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-ArchiveFrequence']) {
          this.settings['HRTP-ArchiveFrequence'] = this.hrtpArchiveFrequenceYear + ',' + newMonth + ',' + this.hrtpArchiveFrequenceDay
        } else {
          this.settings['HRTP-ArchiveFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    hrtpArchiveFrequenceDay : {
      get () {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['HRTP-ArchiveFrequence'] ? this.originalSettings['HRTP-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-ArchiveFrequence']) {
          this.settings['HRTP-ArchiveFrequence'] = this.hrtpArchiveFrequenceYear + ',' + this.hrtpArchiveFrequenceMonth + ',' + newDay
        } else {
          this.settings['HRTP-ArchiveFrequence'] = '0,0,' + newDay
        }
      }
    },
    hrtpLastArchive (){
      return this.$options.filters.formatDateTime(this.settings.HRTP_LastArchive)
    },
    hrtpLastPurge (){
      return this.$options.filters.formatDateTime(this.settings.HRTP_LastPurge)
    },
    hrtpPurgeDelayYear : {
      get () {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['HRTP-PurgeDelay'] ? this.originalSettings['HRTP-PurgeDelay'].split(',')[0] : '0'
        }
        if (this.settings['HRTP-PurgeDelay']) {
          this.settings['HRTP-PurgeDelay'] = newYear + ',' + this.hrtpPurgeDelayMonth + ',' + this.hrtpPurgeDelayDay
        } else {
          this.settings['HRTP-PurgeDelay'] = newYear + ',0,0'
        }
      }
    },
    hrtpPurgeDelayMonth : {
      get () {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['HRTP-PurgeDelay'] ? this.originalSettings['HRTP-PurgeDelay'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-PurgeDelay']) {
          this.settings['HRTP-PurgeDelay'] = this.hrtpPurgeDelayYear + ',' + newMonth + ',' + this.hrtpPurgeDelayDay
        } else {
          this.settings['HRTP-PurgeDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    hrtpPurgeDelayDay : {
      get () {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['HRTP-PurgeDelay'] ? this.originalSettings['HRTP-PurgeDelay'].split(',')[2] : '0'
        }
        if (this.settings['HRTP-PurgeDelay']) {
          this.settings['HRTP-PurgeDelay'] = this.hrtpPurgeDelayYear + ',' + this.hrtpPurgeDelayMonth + ',' + newDay
        } else {
          this.settings['HRTP-PurgeDelay'] = '0,0,' + newDay
        }
      }
    },
    hrtpPurgeFrequenceYear : {
      get () {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['HRTP-PurgeFrequence'] ? this.originalSettings['HRTP-PurgeFrequence'].split(',')[0] : '0'
        }
        if (this.settings['HRTP-PurgeFrequence']) {
          this.settings['HRTP-PurgeFrequence'] = newYear + ',' + this.hrtpPurgeFrequenceMonth + ',' + this.hrtpPurgeFrequenceDay
        } else {
          this.settings['HRTP-PurgeFrequence'] = newYear + ',0,0'
        }
      }
    },
    hrtpPurgeFrequenceMonth : {
      get () {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['HRTP-PurgeFrequence'] ? this.originalSettings['HRTP-PurgeFrequence'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-PurgeFrequence']) {
          this.settings['HRTP-PurgeFrequence'] = this.hrtpPurgeFrequenceYear + ',' + newMonth + ',' + this.hrtpPurgeFrequenceDay
        } else {
          this.settings['HRTP-PurgeFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    hrtpPurgeFrequenceDay : {
      get () {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['HRTP-PurgeFrequence'] ? this.originalSettings['HRTP-PurgeFrequence'].split(',')[2] : '0'
        }
        if (this.settings['HRTP-PurgeFrequence']) {
          this.settings['HRTP-PurgeFrequence'] = this.hrtpPurgeFrequenceYear + ',' + this.hrtpPurgeFrequenceMonth + ',' + newDay
        } else {
          this.settings['HRTP-PurgeFrequence'] = '0,0,' + newDay
        }
      }
    },
    psd2ArchiveDelayYear : {
      get () {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['PSD2-ArchiveDelay'] ? this.originalSettings['PSD2-ArchiveDelay'].split(',')[0] : '0'
        }
        if (this.settings['PSD2-ArchiveDelay']) {
          this.settings['PSD2-ArchiveDelay'] = newYear + ',' + this.psd2ArchiveDelayMonth + ',' + this.psd2ArchiveDelayDay
        } else {
          this.settings['PSD2-ArchiveDelay'] = newYear + ',0,0'
        }
      }
    },
    psd2ArchiveDelayMonth : {
      get () {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['PSD2-ArchiveDelay'] ? this.originalSettings['PSD2-ArchiveDelay'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-ArchiveDelay']) {
          this.settings['PSD2-ArchiveDelay'] = this.psd2ArchiveDelayYear + ',' + newMonth + ',' + this.psd2ArchiveDelayDay
        } else {
          this.settings['PSD2-ArchiveDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    psd2ArchiveDelayDay : {
      get () {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['PSD2-ArchiveDelay'] ? this.originalSettings['PSD2-ArchiveDelay'].split(',')[2] : '0'
        }
        if (this.settings['PSD2-ArchiveDelay']) {
          this.settings['PSD2-ArchiveDelay'] = this.psd2ArchiveDelayYear + ',' + this.psd2ArchiveDelayMonth + ',' + newDay
        } else {
          this.settings['PSD2-ArchiveDelay'] = '0,0,' + newDay
        }
      }
    },
    psd2ArchiveFrequenceYear : {
      get () {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['PSD2-ArchiveFrequence'] ? this.originalSettings['PSD2-ArchiveFrequence'].split(',')[0] : '0'
        }
        if (this.settings['PSD2-ArchiveFrequence']) {
          this.settings['PSD2-ArchiveFrequence'] = newYear + ',' + this.psd2ArchiveFrequenceMonth + ',' + this.psd2ArchiveFrequenceDay
        } else {
          this.settings['PSD2-ArchiveFrequence'] = newYear + ',0,0'
        }
      }
    },
    psd2ArchiveFrequenceMonth : {
      get () {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['PSD2-ArchiveFrequence'] ? this.originalSettings['PSD2-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-ArchiveFrequence']) {
          this.settings['PSD2-ArchiveFrequence'] = this.psd2ArchiveFrequenceYear + ',' + newMonth + ',' + this.psd2ArchiveFrequenceDay
        } else {
          this.settings['PSD2-ArchiveFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    psd2ArchiveFrequenceDay : {
      get () {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['PSD2-ArchiveFrequence'] ? this.originalSettings['PSD2-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-ArchiveFrequence']) {
          this.settings['PSD2-ArchiveFrequence'] = this.psd2ArchiveFrequenceYear + ',' + this.psd2ArchiveFrequenceMonth + ',' + newDay
        } else {
          this.settings['PSD2-ArchiveFrequence'] = '0,0,' + newDay
        }
      }
    },
    psd2LastArchive (){
      return this.$options.filters.formatDateTime(this.settings.PSD2_LastArchive)
    },
    psd2LastPurge (){
      return this.$options.filters.formatDateTime(this.settings.PSD2_LastPurge)
    },
    psd2PurgeDelayYear : {
      get () {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['PSD2-PurgeDelay'] ? this.originalSettings['PSD2-PurgeDelay'].split(',')[0] : '0'
        }
        if (this.settings['PSD2-PurgeDelay']) {
          this.settings['PSD2-PurgeDelay'] = newYear + ',' + this.psd2PurgeDelayMonth + ',' + this.psd2PurgeDelayDay
        } else {
          this.settings['PSD2-PurgeDelay'] = newYear + ',0,0'
        }
      }
    },
    psd2PurgeDelayMonth : {
      get () {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['PSD2-PurgeDelay'] ? this.originalSettings['PSD2-PurgeDelay'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-PurgeDelay']) {
          this.settings['PSD2-PurgeDelay'] = this.psd2PurgeDelayYear + ',' + newMonth + ',' + this.psd2PurgeDelayDay
        } else {
          this.settings['PSD2-PurgeDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    psd2PurgeDelayDay : {
      get () {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['PSD2-PurgeDelay'] ? this.originalSettings['PSD2-PurgeDelay'].split(',')[2] : '0'
        }
        if (this.settings['PSD2-PurgeDelay']) {
          this.settings['PSD2-PurgeDelay'] = this.psd2PurgeDelayYear + ',' + this.psd2PurgeDelayMonth + ',' + newDay
        } else {
          this.settings['PSD2-PurgeDelay'] = '0,0,' + newDay
        }
      }
    },
    psd2PurgeFrequenceYear : {
      get () {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['PSD2-PurgeFrequence'] ? this.originalSettings['PSD2-PurgeFrequence'].split(',')[0] : '0'
        }
        if (this.settings['PSD2-PurgeFrequence']) {
          this.settings['PSD2-PurgeFrequence'] = newYear + ',' + this.psd2PurgeFrequenceMonth + ',' + this.psd2PurgeFrequenceDay
        } else {
          this.settings['PSD2-PurgeFrequence'] = newYear + ',0,0'
        }
      }
    },
    psd2PurgeFrequenceMonth : {
      get () {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['PSD2-PurgeFrequence'] ? this.originalSettings['PSD2-PurgeFrequence'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-PurgeFrequence']) {
          this.settings['PSD2-PurgeFrequence'] = this.psd2PurgeFrequenceYear + ',' + newMonth + ',' + this.psd2PurgeFrequenceDay
        } else {
          this.settings['PSD2-PurgeFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    psd2PurgeFrequenceDay : {
      get () {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['PSD2-PurgeFrequence'] ? this.originalSettings['PSD2-PurgeFrequence'].split(',')[2] : '0'
        }
        if (this.settings['PSD2-PurgeFrequence']) {
          this.settings['PSD2-PurgeFrequence'] = this.psd2PurgeFrequenceYear + ',' + this.psd2PurgeFrequenceMonth + ',' + newDay
        } else {
          this.settings['PSD2-PurgeFrequence'] = '0,0,' + newDay
        }
      }
    },
    srtpArchiveDelayYear : {
      get () {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SRTP-ArchiveDelay'] ? this.originalSettings['SRTP-ArchiveDelay'].split(',')[0] : '0'
        }
        if (this.settings['SRTP-ArchiveDelay']) {
          this.settings['SRTP-ArchiveDelay'] = newYear + ',' + this.srtpArchiveDelayMonth + ',' + this.srtpArchiveDelayDay
        } else {
          this.settings['SRTP-ArchiveDelay'] = newYear + ',0,0'
        }
      }
    },
    srtpArchiveDelayMonth : {
      get () {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SRTP-ArchiveDelay'] ? this.originalSettings['SRTP-ArchiveDelay'].split(',')[1] : '0'
        }
        if (this.settings['SRTP-ArchiveDelay']) {
          this.settings['SRTP-ArchiveDelay'] = this.srtpArchiveDelayYear + ',' + newMonth + ',' + this.srtpArchiveDelayDay
        } else {
          this.settings['SRTP-ArchiveDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    srtpArchiveDelayDay : {
      get () {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SRTP-ArchiveDelay'] ? this.originalSettings['SRTP-ArchiveDelay'].split(',')[2] : '0'
        }
        if (this.settings['SRTP-ArchiveDelay']) {
          this.settings['SRTP-ArchiveDelay'] = this.srtpArchiveDelayYear + ',' + this.srtpArchiveDelayMonth + ',' + newDay
        } else {
          this.settings['SRTP-ArchiveDelay'] = '0,0,' + newDay
        }
      }
    },
    srtpArchiveFrequenceYear : {
      get () {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SRTP-ArchiveFrequence'] ? this.originalSettings['SRTP-ArchiveFrequence'].split(',')[0] : '0'
        }
        if (this.settings['SRTP-ArchiveFrequence']) {
          this.settings['SRTP-ArchiveFrequence'] = newYear + ',' + this.srtpArchiveFrequenceMonth + ',' + this.srtpArchiveFrequenceDay
        } else {
          this.settings['SRTP-ArchiveFrequence'] = newYear + ',0,0'
        }
      }
    },
    srtpArchiveFrequenceMonth : {
      get () {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SRTP-ArchiveFrequence'] ? this.originalSettings['SRTP-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['SRTP-ArchiveFrequence']) {
          this.settings['SRTP-ArchiveFrequence'] = this.srtpArchiveFrequenceYear + ',' + newMonth + ',' + this.srtpArchiveFrequenceDay
        } else {
          this.settings['SRTP-ArchiveFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    srtpArchiveFrequenceDay : {
      get () {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SRTP-ArchiveFrequence'] ? this.originalSettings['SRTP-ArchiveFrequence'].split(',')[2] : '0'
        }
        if (this.settings['SRTP-ArchiveFrequence']) {
          this.settings['SRTP-ArchiveFrequence'] = this.srtpArchiveFrequenceYear + ',' + this.srtpArchiveFrequenceMonth + ',' + newDay
        } else {
          this.settings['SRTP-ArchiveFrequence'] = '0,0,' + newDay
        }
      }
    },
    srtpLastArchive (){
      return this.$options.filters.formatDateTime(this.settings.SRTP_LastArchive)
    },
    srtpLastPurge (){
      return this.$options.filters.formatDateTime(this.settings.SRTP_LastPurge)
    },
    srtpPurgeDelayYear : {
      get () {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SRTP-PurgeDelay'] ? this.originalSettings['SRTP-PurgeDelay'].split(',')[0] : '0'
        }
        if (this.settings['SRTP-PurgeDelay']) {
          this.settings['SRTP-PurgeDelay'] = newYear + ',' + this.srtpPurgeDelayMonth + ',' + this.srtpPurgeDelayDay
        } else {
          this.settings['SRTP-PurgeDelay'] = newYear + ',0,0'
        }
      }
    },
    srtpPurgeDelayMonth : {
      get () {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SRTP-PurgeDelay'] ? this.originalSettings['SRTP-PurgeDelay'].split(',')[1] : '0'
        }
        if (this.settings['SRTP-PurgeDelay']) {
          this.settings['SRTP-PurgeDelay'] = this.srtpPurgeDelayYear + ',' + newMonth + ',' + this.srtpPurgeDelayDay
        } else {
          this.settings['SRTP-PurgeDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    srtpPurgeDelayDay : {
      get () {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SRTP-PurgeDelay'] ? this.originalSettings['SRTP-PurgeDelay'].split(',')[2] : '0'
        }
        if (this.settings['SRTP-PurgeDelay']) {
          this.settings['SRTP-PurgeDelay'] = this.srtpPurgeDelayYear + ',' + this.srtpPurgeDelayMonth + ',' + newDay
        } else {
          this.settings['SRTP-PurgeDelay'] = '0,0,' + newDay
        }
      }
    },
    srtpPurgeFrequenceYear : {
      get () {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SRTP-PurgeFrequence'] ? this.originalSettings['SRTP-PurgeFrequence'].split(',')[0] : '0'
        }
        if (this.settings['SRTP-PurgeFrequence']) {
          this.settings['SRTP-PurgeFrequence'] = newYear + ',' + this.srtpPurgeFrequenceMonth + ',' + this.srtpPurgeFrequenceDay
        } else {
          this.settings['SRTP-PurgeFrequence'] = newYear + ',0,0'
        }
      }
    },
    srtpPurgeFrequenceMonth : {
      get () {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SRTP-PurgeFrequence'] ? this.originalSettings['SRTP-PurgeFrequence'].split(',')[1] : '0'
        }
        if (this.settings['SRTP-PurgeFrequence']) {
          this.settings['SRTP-PurgeFrequence'] = this.srtpPurgeFrequenceYear + ',' + newMonth + ',' + this.srtpPurgeFrequenceDay
        } else {
          this.settings['SRTP-PurgeFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    srtpPurgeFrequenceDay : {
      get () {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SRTP-PurgeFrequence'] ? this.originalSettings['SRTP-PurgeFrequence'].split(',')[2] : '0'
        }
        if (this.settings['SRTP-PurgeFrequence']) {
          this.settings['SRTP-PurgeFrequence'] = this.srtpPurgeFrequenceYear + ',' + this.srtpPurgeFrequenceMonth + ',' + newDay
        } else {
          this.settings['SRTP-PurgeFrequence'] = '0,0,' + newDay
        }
      }
    },
    role () {
      return this.tabName
    }
  },
  created() {
    this.environnments = [
      {"name": "development", "value": "4"},
      {"name": "qualification", "value": "3"},
      {"name": "staging", "value": "2"},
      {"name": "production", "value": "1"}
    ]
    this.getSettings()
  },
  methods: {
    changeMaxAmountHRTP() {
      if(this.settings['HRTP-RTPSPMaxAmount']) {
        if (this.settings['HRTP-RTPSPMaxAmount'].includes('e')) {
          this.settings['HRTP-RTPSPMaxAmount'] = parseFloat(this.settings['HRTP-RTPSPMaxAmount'].split('e')[0]) * Math.pow(10, parseInt(this.settings['HRTP-RTPSPMaxAmount'].split('e')[1]))
        }
        if(this.settings['HRTP-RTPSPMaxAmount'].length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings['HRTP-RTPSPMaxAmount'].slice(this.settings['HRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings['HRTP-RTPSPMaxAmount'].split('.')[0]
          this.settings['HRTP-RTPSPMaxAmount'] = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings['HRTP-RTPSPMaxAmount'] = parseFloat(this.settings['HRTP-RTPSPMaxAmount']).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeMaxAmountSRTP() {
      if(this.settings['SRTP-RTPSPMaxAmount']) {
        if (this.settings['SRTP-RTPSPMaxAmount'].includes('e')) {
          this.settings['SRTP-RTPSPMaxAmount'] = parseFloat(this.settings['SRTP-RTPSPMaxAmount'].split('e')[0]) * Math.pow(10, parseInt(this.settings['SRTP-RTPSPMaxAmount'].split('e')[1]))
        }
        if(this.settings['SRTP-RTPSPMaxAmount'].length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings['SRTP-RTPSPMaxAmount'].slice(this.settings['SRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings['SRTP-RTPSPMaxAmount'].split('.')[0]
          this.settings['SRTP-RTPSPMaxAmount'] = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings['SRTP-RTPSPMaxAmount'] = parseFloat(this.settings['SRTP-RTPSPMaxAmount']).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeMaxLinesExportRTP () {
      let newMonth = parseInt(this.settings['RTPMaxLinesExport'], 10).toString()
      if (newMonth === 'NaN' || !newMonth) {
        this.settings['RTPMaxLinesExport'] = this.originalSettings['RTPMaxLinesExport']
        this.resetInput = !this.resetInput
        return
      }
      this.settings['RTPMaxLinesExport'] = parseInt(this.settings['RTPMaxLinesExport'], 10).toString()
    },
    changeSettingInterval(value, stringParam) {
      let formatedValue

      formatedValue = value.replace(/[YM]/g, ',')
      formatedValue = formatedValue.replace(/[D]/g, '')
      this.settings[stringParam] = formatedValue
    },
    changeSettingInterval(value, stringParam) {
      let formatedValue

      formatedValue = value.replace(/[YM]/g, ',')
      formatedValue = formatedValue.replace(/[D]/g, '')
      this.settings[stringParam] = formatedValue
    },
    changeTimeBeforeExpSRTP() {
      if(this.settings.RTPSPTimeBeforeExpiration) {
        this.settings.RTPSPTimeBeforeExpiration = parseInt(this.settings.RTPSPTimeBeforeExpiration, 10).toString()
      } else {
        return
      }
    },
    changeVldityPeriodHRTP() {
      if(this.settings['HRTP-ValidityPeriod']) {
        this.settings['HRTP-ValidityPeriod'] = parseInt(this.settings['HRTP-ValidityPeriod'], 10).toString()
      } else {
        return
      }
    },
    controlMaxAmountHRTP () {
      let newAmount = parseFloat('.' + this.settings['HRTP-RTPSPMaxAmount'].slice(this.settings['HRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
      if (newAmount === 'NaN' || !newAmount) {
        this.settings['HRTP-RTPSPMaxAmount'] = this.originalSettings['HRTP-RTPSPMaxAmount']
        this.resetInput = !this.resetInput
        return
      }
    },
    controlMaxAmountSRTP () {
      let newAmount = parseFloat('.' + this.settings['SRTP-RTPSPMaxAmount'].slice(this.settings['SRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
      if (newAmount === 'NaN' || !newAmount) {
        this.settings['SRTP-RTPSPMaxAmount'] = this.originalSettings['SRTP-RTPSPMaxAmount']
        this.resetInput = !this.resetInput
        return
      }
    },
    controlTimeBeforeExpSRTP () {
      let newTimer = parseInt(this.settings.RTPSPTimeBeforeExpiration, 10).toString()
      if (newTimer === 'NaN' || !newTimer) {
        this.settings.RTPSPTimeBeforeExpiration = this.originalSettings.RTPSPTimeBeforeExpiration
        this.resetInput = !this.resetInput
        return
      }
    },
    controlTimeBeforeExpHRTP () {
      let newTimer = parseInt(this.settings['HRTP-ValidityPeriod'], 10).toString()
      if (newTimer === 'NaN' || !newTimer) {
        this.settings['HRTP-ValidityPeriod'] = this.originalSettings['HRTP-ValidityPeriod']
        this.resetInput = !this.resetInput
        return
      }
    },
    getSettings () {
      this.activateSpinner = true
      let that = this
      this.$engine.services.payments.fetchGlobalSettings().then((resp) => {
        that.settings['RTPMaxLinesExport'] = resp.data.GlobalRTPSettings['RTPMaxLinesExport']
        that.settings['Environment'] = resp.data.GlobalRTPSettings['Environment']
        that.settings.RTPSPIdentifier = resp.data.GlobalRTPSettings.RTPSPIdentifier
        that.settings['SRTP-API-AccountValidation'] = resp.data.GlobalRTPSettings['SRTP-API-AccountValidation']
        that.settings['HRTP-Identifier'] = resp.data.GlobalRTPSettings['HRTP-Identifier']
        that.settings['HRTP-API-AccountValidation'] = resp.data.GlobalRTPSettings['HRTP-API-AccountValidation']
        that.settings['SRTP-RTPSPMaxAmount'] = resp.data.GlobalRTPSettings['SRTP-RTPSPMaxAmount']
        that.settings['HRTP-RTPSPMaxAmount'] = resp.data.GlobalRTPSettings['HRTP-RTPSPMaxAmount']
        that.settings['HRTP-ValidityPeriod'] = resp.data.GlobalRTPSettings['HRTP-ValidityPeriod']
        that.settings.RTPSPTimeBeforeExpiration = resp.data.GlobalRTPSettings.RTPSPTimeBeforeExpiration
        that.settings['SRTP-PurgeFrequence'] = resp.data.GlobalRTPSettings['SRTP-PurgeFrequence']
        that.settings['HRTP-PurgeFrequence'] = resp.data.GlobalRTPSettings['HRTP-PurgeFrequence']
        that.settings['PSD2-PurgeFrequence'] = resp.data.GlobalRTPSettings['PSD2-PurgeFrequence']
        that.settings['SRTP-PurgeDelay'] = resp.data.GlobalRTPSettings['SRTP-PurgeDelay']
        that.settings['HRTP-PurgeDelay'] = resp.data.GlobalRTPSettings['HRTP-PurgeDelay']
        that.settings['PSD2-PurgeDelay'] = resp.data.GlobalRTPSettings['PSD2-PurgeDelay']
        that.settings['SRTP-ArchiveFrequence'] = resp.data.GlobalRTPSettings['SRTP-ArchiveFrequence']
        that.settings['HRTP-ArchiveFrequence'] = resp.data.GlobalRTPSettings['HRTP-ArchiveFrequence']
        that.settings['PSD2-ArchiveFrequence'] = resp.data.GlobalRTPSettings['PSD2-ArchiveFrequence']
        that.settings['SRTP-ArchiveDelay'] = resp.data.GlobalRTPSettings['SRTP-ArchiveDelay']
        that.settings['HRTP-ArchiveDelay'] = resp.data.GlobalRTPSettings['HRTP-ArchiveDelay']
        that.settings['PSD2-ArchiveDelay'] = resp.data.GlobalRTPSettings['PSD2-ArchiveDelay']
        that.settings['PSD2-Token.io-RedirectURL'] = resp.data.GlobalRTPSettings['PSD2-Token.io-RedirectURL']
        that.settings.SRTP_LastPurge = resp.data.GlobalRTPSettings.SRTP_LastPurge
        that.settings.HRTP_LastPurge = resp.data.GlobalRTPSettings.HRTP_LastPurge
        that.settings.PSD2_LastPurge = resp.data.GlobalRTPSettings.PSD2_LastPurge
        that.settings.SRTP_LastArchive = resp.data.GlobalRTPSettings.SRTP_LastArchive
        that.settings.HRTP_LastArchive = resp.data.GlobalRTPSettings.HRTP_LastArchive
        that.settings.PSD2_LastArchive = resp.data.GlobalRTPSettings.PSD2_LastArchive
        that.activateSpinner = false
        that.originalSettings = Object.assign({}, that.settings)
      })
    },
    editSettings () {
      this.doesEdit = true
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, true)
    },
    resetSettings () {
      this.getSettings()
      this.doesEdit = false
    },
    updateSettings (settings) {
      let that = this

      // CHECK GLOBAL SETTINGS
      if (!this.settings['RTPMaxLinesExport']) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_lines_export')}))
        return
      }
      if (!this.settings['Environment']) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.environnment_type')}))
        return
      }

      // CHECK SRTP SETTINGS
      if (this.canSeeSRTP) {
        if (!this.settings.RTPSPIdentifier) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_identifier')}))
          return
        }
        if (!this.settings['SRTP-API-AccountValidation']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_api_accountvalidation')}))
          return
        }
        if (!this.settings.RTPSPTimeBeforeExpiration) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_time_before_expiration')}))
          return
        }
        if (!this.settings['SRTP-RTPSPMaxAmount']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_amnt_srtp')}))
          return
        }
        if (!this.settings['SRTP-PurgeFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_purge_freq')}))
          return
        }
        if (!this.settings['SRTP-PurgeDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_purge_delay')}))
          return
        }
        if (!this.settings['SRTP-ArchiveFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_archive_freq')}))
          return
        }
        if (!this.settings['SRTP-ArchiveDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_archive_delay')}))
          return
        }
      }

      // CHECK HRTP SETTINGS
      if (this.canSeeHRTP) {
        if (!this.settings['HRTP-Identifier']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.hrtp_identifier')}))
          return
        }
        if (!this.settings['HRTP-API-AccountValidation']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.hrtp_api_accountvalidation')}))
          return
        }
        if (!this.settings['HRTP-RTPSPMaxAmount']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_amnt_hrtp')}))
          return
        }
        if (!this.settings['HRTP-ValidityPeriod']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_h_validity_period')}))
          return
        }
        if (!this.settings['HRTP-PurgeFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_purge_freq')}))
          return
        }
        if (!this.settings['HRTP-PurgeDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_purge_delay')}))
          return
        }
        if (!this.settings['HRTP-ArchiveFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_archive_freq')}))
          return
        }
        if (!this.settings['HRTP-ArchiveDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_archive_delay')}))
          return
        }
      }

      // CHECK SRTP SETTINGS
      if (this.canSeePSD2) {
        if (!this.settings['PSD2-Token.io-RedirectURL']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.tokenio_redirecturl')}))
          return
        }
        if (!this.settings['PSD2-PurgeFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_purge_freq')}))
          return
        }
        if (!this.settings['PSD2-PurgeDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_purge_delay')}))
          return
        }
        if (!this.settings['PSD2-ArchiveFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_archive_freq')}))
          return
        }
        if (!this.settings['PSD2-ArchiveDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_archive_delay')}))
          return
        }
      }

      let array = []
      let changedSettings = {}

      Object.keys(settings).forEach((key) => {
        if (settings[key] !== this.originalSettings[key]) {
          changedSettings[key] = settings[key]
        }
      })
      Object.entries(changedSettings).forEach((element) => {
        let object = {}
        object = {
          name: element[0],
          value: element[1],
        }
        array.push(object)
      })

      let data = array
      this.$engine.services.payments
        .updateGlobalSettings({ data })
        .then((resp) => {
          this.originalSettings = Object.assign({}, settings)
          this.doesEdit = false
          that.$f7.modal({
            title: that.$i18n.t("settings.settings_modified"),
            buttons: [
              {
                text: "OK",
                onClick: function () {
                  return
                },
              },
            ],
          })
          loadPage(that, { url: "/settings/rtpSettings/" })
        })
        .catch((e) => {
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (e && e.response && e.response.data && e.response.data.error) {
            let errParsed = e.response.data.error.replace(/\s+/g, '')
            if (('errors._specific.title.' + errParsed) !== that.$t('errors._specific.title.' + errParsed)) {
              errMsgTitle = that.$t('errors._specific.title.' + errParsed)
              errMsgDesc = that.$t('errors._specific.description.' + errParsed)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(e, that)
          }
        })
    },
  },
}
</script>
